function handleFirstTab(e: KeyboardEvent): void {
  if (e.key === "Tab") {
    document.body.classList.add("keyboardFocus");
    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce(): void {
  document.body.classList.remove("keyboardFocus");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

export const initKeyboardFocus = (): void => {
  window.addEventListener("keydown", handleFirstTab);
};

export const hasKeyboardFocus = (): boolean => {
  return document.body.classList.contains("keyboardFocus");
};
